import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	TranslatedString,
	Dialog, DialogHeadline,
	PrimaryButton, SecondaryButton
} from '@bosch/bt-ui';

import './ConfirmDialog.css';
import withErrorHandler from './ErrorHandler';

const ConfirmDialog = (props) => {
	const {
		openConfirm,
		descTranslatedId,
		setConfirmOpen,
		onConfirm
    } = props;

	const onCloseModal = () => setConfirmOpen(false);

	return (
		<Dialog onClose={onCloseModal} 
			dialogOptions={{
				open: openConfirm
			}}
			title={<TranslatedString stringId="dialog-warning" />}
			// Can be either "error", "warning", "success", "info", or "none"
			alertType="warning"
		>
			<DialogHeadline>
				<TranslatedString stringId="are-you-sure" />
			</DialogHeadline>
			{descTranslatedId &&(
				<div className="dialog-description">
					<TranslatedString stringId={descTranslatedId} />
				</div>
			)}
			<div className="dialog-confirm-button">
				<PrimaryButton type="button" onClick={onConfirm}>
					<TranslatedString stringId="button-confirm" />
				</PrimaryButton>
				<SecondaryButton type="button" onClick={onCloseModal}>
					<TranslatedString stringId="button-cancel" />
				</SecondaryButton>
			</div>
		</Dialog>
	);
}

export default withErrorHandler(ConfirmDialog);